var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonOlja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 516.48,
    width: 253.09,
    height: 49.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 256.45,
    y: 185.58,
    width: 253.09,
    height: 49.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 261.96,
    y: 367.93,
    width: 238.94,
    height: 12.58
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 423.87,
    y: 173,
    width: 44.02,
    height: 24.37
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 271.39,
    y: 248.46,
    width: 220.08,
    height: 254.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.85,400.76a63.05,63.05,0,0,1-63.05,63.06c-34.83,0-62.63-28.23-63.06-63.06-.43-34.25,31.89-72.6,63.06-113C411.59,326.07,444.85,365.94,444.85,400.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonOlja);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-olja.20f95698590be1daf7267923dbdfc519.svg";
export { ForwardRef as ReactComponent };